import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || '', // avoid undefined
  sendDefaultPii: true,
  environment: import.meta.env.MODE || 'development'
});